export default "__VITE_ASSET__nWq4hdF2__"